<template>
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
  >
    <path d="M13 5C13 5.41422 12.6642 5.75 12.25 5.75L3.46302 5.75L6.75009 8.69106C7.05878 8.96726 7.08512 9.4414 6.80893 9.75009C6.53273 10.0588 6.05859 10.0851 5.7499 9.80892L0.999904 5.55893C0.840887 5.41665 0.75 5.21338 0.75 5C0.75 4.78663 0.840886 4.58335 0.999904 4.44107L5.7499 0.191076C6.05859 -0.0851191 6.53273 -0.0587781 6.80893 0.24991C7.08512 0.558599 7.05878 1.03274 6.75009 1.30894L3.46302 4.25L12.25 4.25C12.6642 4.25 13 4.58579 13 5Z" />
  </svg>
</template>
